export enum TimeCodesActionType {
  SET_TIME_CODES = 'SET_TIME_CODES',
  UPDATE_TIME_CODE = 'UPDATE_TIME_CODE',
  SET_TIMECODES_LOADING_STATUS = 'SET_TIMECODES_LOADING_STATUS',
  SET_TIME_CODES_PAGINATION = 'SET_TIME_CODES_PAGINATION',
  SET_TIME_CODES_AFTER_SCROLL = 'SET_TIME_CODES_AFTER_SCROLL',
}
